import styled from 'styled-components';
export const DynamicGradientBackground = styled.div `
  /* Define the custom properties with proper types for smooth transitions */
  --gradientTop: ${({ colors }) => colors === null || colors === void 0 ? void 0 : colors.backgroundColor};
  --gradientBottom: ${({ colors }) => (colors === null || colors === void 0 ? void 0 : colors.backgroundBottomColor) || (colors === null || colors === void 0 ? void 0 : colors.backgroundColor)};

  background: linear-gradient(
    to bottom,
    var(--gradientTop),
    var(--gradientBottom)
  );
  background-attachment: fixed;
  background-size: cover;
  background-position: center;

  /* Transition the custom properties */
  transition: --gradientTop 0.3s ease, --gradientBottom 0.3s ease;

  width: 100%;
  min-height: 100vh;

  /* CSS @property definitions for smooth gradient animations */
  @property --gradientTop {
    syntax: '<color>';
    inherits: false;
    initial-value: transparent;
  }

  @property --gradientBottom {
    syntax: '<color>';
    inherits: false;
    initial-value: transparent;
  }
`;
